import { combineReducers } from 'redux';
import { DiscountState, initialDiscountState } from './discount/state';
import { discountReducer } from './discount/slice';

export * from './discount';

export type CatalogState = {
  discount: DiscountState;
};

export const initialCatalogState: CatalogState = {
  discount: initialDiscountState,
};

export const catalogReducers = combineReducers({
  discount: discountReducer,
});
